module.exports = __webpack_public_path__ + "media/images/categories/headers/people-dc6ada447db9bff22f9a7922ff51b4bb.jpg";